'use strict';

angular.module('admin.video', [
    'ng-komondor-resource-view',
])

.config(function (resourceStateProvider)
{
    resourceStateProvider
    .state('admin.videos', {
        url: 'videos',
        model: 'Video',
        viewOptions: 'videoViewOptions',
        title: 'Videos',
        modelNameField: 'slug',
        edit: {
            templateUrl: 'admin/video/video.edit.html',
            controller: 'VideoAdminCtrl',
            defaults: {
                display_order: 1,
            }
        },
    });
})

.factory('videoViewOptions', function (
    extendDeep,
    resourceViewOptions,
    listNameTemplate,
    listView
) {
    return extendDeep(angular.copy(resourceViewOptions), {
        queryDefaults: {
            sort: [
                ['id', 'DESC'],
            ],
        },
        list: {
            columns: [
                {
                    label: 'Slug',
                    name: 'slug',
                    sortable: true,
                },
                {
                    label: 'Enabled',
                    name: 'enabled',
                    template: '<span class="no-wrap">{{ model.enabled ? "Yes" : "No"}}</span>',
                    sortable: true,
                },
                {
                    label: 'Url',
                    name: 'video_url',
                    template: '<span class="no-wrap"><a target="_blank" href="{{model.video_url}}">{{model.video_url}}</a></span>',
                    sortable: false,
                },
                {
                    label: 'Last modified',
                    name: 'updated_at',
                    template: '<span class="no-wrap">{{ model.updated_at | date }}</span>',
                    sortable: true,
                },
            ],
        },
        views: [listView],
    });
});
